import { useAppSelector } from 'store/store';
import { ROLE_TENANT_SUPPLIER } from 'shared/permissions/roles';

export function useIsSupplier(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_SUPPLIER) ?? false;
}
